/* ============================================================
   JC PDP behaviours
   1) Sticky add-to-cart bar: appears once the main buy area is
      scrolled past; mirrors the main price + button state via
      observers (so it scales to multi-variant automatically);
      clicking it proxies the real add-to-cart button.
   2) Size-guide (and any) modal: data-jc-modal-* toggles.
   No dependencies. Safe to load once per product page.
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    /* ---- Portal modals to <body> ----
       Guarantees position:fixed is viewport-relative even when an ancestor (e.g. Dawn's
       scroll-reveal wrapper, which keeps transform: translateY(0)) establishes a containing block. */
    document.querySelectorAll('[data-jc-modal]').forEach(function (m) {
      if (m.parentNode !== document.body) document.body.appendChild(m);
    });

    /* ---- Sticky add-to-cart ---- */
    var bar = document.querySelector('[data-jc-sticky]');
    // The main buy area is the only <product-form> with the .product-form class
    // (quick-add forms on cards do not carry that class).
    var mainForm = document.querySelector('product-form.product-form');

    if (bar && mainForm) {
      var mainBtn = mainForm.querySelector('[name="add"]');
      var scope = mainForm.closest('section') || document;
      var mainPrice = scope.querySelector('[id^="price-"] .price') || scope.querySelector('.price');
      var stickyPrice = bar.querySelector('[data-jc-sticky-price]');
      var stickyBtn = bar.querySelector('[data-jc-sticky-add]');
      var stickyLabel = bar.querySelector('[data-jc-sticky-label]');

      function syncPrice() {
        if (mainPrice && stickyPrice) stickyPrice.innerHTML = mainPrice.innerHTML;
      }
      function syncBtn() {
        if (!mainBtn || !stickyBtn) return;
        stickyBtn.disabled = mainBtn.hasAttribute('disabled');
        var srcLabel = mainBtn.querySelector('span');
        if (srcLabel && stickyLabel) stickyLabel.textContent = srcLabel.textContent.trim();
      }

      syncPrice();
      syncBtn();

      if (mainPrice) {
        new MutationObserver(syncPrice).observe(mainPrice, { childList: true, subtree: true, characterData: true });
      }
      if (mainBtn) {
        new MutationObserver(syncBtn).observe(mainBtn, { attributes: true, childList: true, subtree: true });
      }
      if (stickyBtn && mainBtn) {
        stickyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          mainBtn.click();
        });
      }

      // the footer reserves this much room at its bottom while the bar is showing (jc-site-footer.css)
      var setBarH = function () { document.documentElement.style.setProperty('--jc-sticky-atc-h', bar.offsetHeight + 'px'); };
      setBarH();
      if ('ResizeObserver' in window) new ResizeObserver(setBarH).observe(bar);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var scrolledPast = en.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', !en.isIntersecting && scrolledPast);
          });
        }, { threshold: 0 });
        io.observe(mainForm);
      }
    }

    /* ---- Modals (size guide, etc.) ---- */
    var lastFocus = null;

    function openModal(modal, opener) {
      lastFocus = opener || document.activeElement;
      modal.removeAttribute('hidden');
      // force reflow so the transition runs
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.classList.add('jc-modal-open');
      var focusable = modal.querySelector('[data-jc-modal-close], button, a, input, select, textarea');
      if (focusable) focusable.focus();
    }
    function closeModal(modal) {
      modal.classList.remove('is-open');
      document.body.classList.remove('jc-modal-open');
      window.setTimeout(function () { modal.setAttribute('hidden', ''); }, 200);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-jc-modal-open]');
      if (opener) {
        e.preventDefault();
        var modal = document.querySelector(opener.getAttribute('data-jc-modal-open'));
        if (modal) openModal(modal, opener);
        return;
      }
      var closer = e.target.closest('[data-jc-modal-close]');
      if (closer) {
        var owner = closer.closest('[data-jc-modal]');
        if (owner) closeModal(owner);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = document.querySelector('[data-jc-modal].is-open');
        if (open) closeModal(open);
      }
    });
  });
})();
